<a [routerLink]="route" [queryParams]="queryParams" [class.disabled]="!allowNavigation" class="btn">
  <div>
      <div [class.overview-tile-active]="active" class="overview-tile" [ngClass]="backgroundClass">
        <div class="row">
          <div class="center-block">
            <div class="text-left overview-tile-label">
              <h5>{{label}}</h5>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="center-block">
            <div class="text-right">
              <div class="overview-tile-count">
                <h5 *ngIf="showNumber" class="overview-tile-number">{{ number }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</a>
